export class SharedContestantStateService {
    public signUpStepDone = false;
    public selectedTeam = null;
}
